import styled from 'styled-components';

export const GameDesignSlideStyles = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
  BtnWrapper: styled.div`
    margin: 0 auto 20px;
  `,
  ImageWrapper: styled.div`
    position: absolute;
    top: 160px;
    right: 30px;
    z-index: 0;
  `,
};
